import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-app-flexbox-grid';
import moment from 'moment';
import Payment from '../Payment/Payment';
import Loader from '../Loader/Loader';
import Error from '../Error/Error';
import './Sequence.css';
import { network } from '../Network';
import { getSequence } from '../../fetch';
import Table from '../Table/Table';
import {convert} from '../currency';

class Sequence extends Component {
    constructor(props){
        super(props);
        let data = props.params.data;
        let error = props.params.error;
        if(data == null){
            if(
                typeof window !== "undefined" && 
                window != null && window.__INITIAL_STATE__ != null && 
                window.__INITIAL_STATE__.data != null
            ){
                data = window.__INITIAL_STATE__.data;
                window.__INITIAL_STATE__.data = null;
            }
        }
        if(error == null){
            if(
                typeof window !== "undefined" && window != null && 
                window.__INITIAL_STATE__ != null && 
                window.__INITIAL_STATE__.error != null
            ){
                error = window.__INITIAL_STATE__.error;
                window.__INITIAL_STATE__.error = null;
            }
        }
        this.state = {
            id: props.params.id,
            load: data == null && error == null, 
            error: error,
            sequence: data
        }
    }

    componentDidMount(){
        if(this.state.sequence == null && this.state.error == null){
            this.load();
        }
    }

    componentDidUpdate(){
        if(this.state.id !== this.props.params.id){
            this.setState({
                id: this.props.params.id,
                load: true, 
                error: null,
                sequence: null
            });
            this.load(this.props.params.id);
        }
    }

    load(id){
        if(this.state.load === false){
            this.setState({load: true});
        }
        if(id == null){
            id = this.state.id;
        }
        getSequence(id,(data)=>{
            this.setState({load: false, error: data.error, sequence: data.data});
        }, network);
    }

    txs(res){
        return network.getLedgerTransactions(this.state.id, res.successful_transaction_count, (txs)=>{
            res.txs = txs.records;
            Promise.all(txs.records.map((t)=>{
                return network.getTransactionOperationsPromise(t.hash);
            })).then((results)=>{
                results.forEach((o)=>{
                    res.txs = res.txs.map((t)=>{
                        if(t.hash === o.records[0]._links.transaction.href.split('/').pop()){
                            t.ops = o.records;
                        }
                        return t;
                    })
                })
                this.setState({load: false, sequence: res});
                return null;
            }).catch((err)=>{
                console.log(err)
                this.setState({load: false, error: 'Operations for transactions for ledger #' + this.state.id + ' not found', sequence: res});
            });
            return null;
        },(err)=>{
            console.log(err)
            this.setState({load: false, error: 'Transactions for ledger #' + this.state.id + ' not found', sequence: res});
        });
    }

    render() {
        if(this.state.sequence != null){
            var ledger, info, count, payments = [];
            
            ledger = { 
                headers:[{width:"40%"},{width:"60%",align:'right'}],
                items:[
                    [{text:'Sequence'},{text:this.state.sequence.sequence}],
                    [{text:'Hash'},{text:this.state.sequence.hash}],
                    [{text:'Closed At'},{text:moment(this.state.sequence.closed_at).format('YYYY-MM-DD HH:mm:ss')}],
                ]
            };

            info = { 
                headers:[{width:"40%"},{width:"60%",align:'right'}],
                items:[
                    [{text:'Base Fee'},{text:(
                        (this.state.sequence.base_fee_in_stroops != null || this.state.sequence.base_fee_in_nibbs != null)
                          ? (convert(Number(this.state.sequence.base_fee_in_stroops || this.state.sequence.base_fee_in_nibbs),"dbits")+" "+this.props.currency)
                          : (convert(Number(this.state.sequence.base_fee),"dbits")+" "+this.props.currency)
                    )}],
                    [{text:'Fee Pool'},{text:convert(Number(this.state.sequence.fee_pool),this.props.currency)+" "+this.props.currency}],
                    [{text:'Total Coins'},{text:convert(Number(this.state.sequence.total_coins),this.props.currency)+" "+this.props.currency}],
                ]
            };

            count = {
                headers:[{width:"50%",align:'center'},{width:"50%",align:'center'}],
                items:[
                    [{text:'Transactions'},{text:'Operations'}],
                    [{text:this.state.sequence.successful_transaction_count},{text:this.state.sequence.operation_count}]
                ]
            };
            if(this.state.sequence.txs !== null && this.state.sequence.txs !== undefined){
                this.state.sequence.txs.forEach((p,i)=>{
                    payments.push(
                        <Col xs={12} key={"payment" + i} className={i%2 === 0 ? "over" : ""}>
                            <div className="transaction-block">
                                <Payment payment={p} currency={this.props.currency}/> 
                            </div>
                        </Col>
                )});
            }
        }
        return ( 
            <Grid fluid className="sequence">
            {this.state.load && <Loader/>}
                {this.state.sequence != null &&
                    <Row>
                        <Col xs={12} md={12}>
                            <div className="sequence-block">
                                <h2 className="sequence-title">Ledger</h2>
                                <Table data={ledger}/>
                            </div>
                        </Col>
                        <Col xs={12} md={7} className="over">
                            <div className="sequence-block">
                                <h2 className="sequence-title">Info</h2>
                                <Table data={info}/>
                            </div>
                        </Col>
                        <Col xs={12} md={5}> 
                            <div className="sequence-block">
                                <h2 className="sequence-title">Count</h2>
                                <Table data={count}/>
                            </div>
                        </Col>
                        {payments}
                    </Row>
                }
                {this.state.error != null &&
                    <Error message={this.state.error}/>
                }
            </Grid>
        );
    }
}

export default Sequence;


// WEBPACK FOOTER //
// ./src/components/Sequence/Sequence.js